window.onload = function() {
    // Check if the body has the class "template-rolunk_irtak"
    if (document.body.classList.contains('template-rolunk_irtak')) {
        // Select all elements with class ".image-with-text"
        const elements = document.querySelectorAll('.image-with-text');
        
        // Loop through each element
        elements.forEach(element => {
            // Check if the element contains an <svg> element
            const svgElements = element.getElementsByTagName('svg');
            
            // Convert HTMLCollection to array and check length
            if (svgElements.length > 0) {
                // Hide the element if it contains an <svg> element
                element.style.display = 'none';
            }
        });
    }
};

// Find the element by class
var element = document.querySelector('.section-template--24554782228825__page_7wQKAw-padding');

// Check if the element exists and remove the class
if (element) {
    element.classList.remove('page-width--narrow');
} else {
    console.log("Element not found");
}


   



/* VIDEÓ KÓD MOBILRA



document.addEventListener("DOMContentLoaded", function () {
  // Function to check screen size and update video source
  function updateVideoSource() {
    const section = document.getElementById("shopify-section-template--24222516150617__media-slideshow");
    
    if (section) {
      const videoElement = section.querySelector("video");
      if (videoElement) {
        const sourceElement = videoElement.querySelector("source");

        if (window.innerWidth <= 768) {
          // Replace the video URL for mobile
          sourceElement.setAttribute(
            "src",
            "https://cdn.shopify.com/videos/c/o/v/01b6e065a4b74fa4b29ba76ed173e482.mp4"
          );
        } else {
          // Replace with the default video URL for larger screens
          sourceElement.setAttribute(
            "src",
            "//simbioplus.hu/cdn/shop/videos/c/vp/1b53996212b24f16bf040fd871ec7392/1b53996212b24f16bf040fd871ec7392.HD-720p-4.5Mbps-33773106.mp4"
          );
        }

        // Reload the video to apply the new source
        videoElement.load();
      }
    }
  }

  // Initial check
  updateVideoSource();

  // Add a resize event listener to handle screen size changes
  window.addEventListener("resize", updateVideoSource);
});

*/

(function () {
  var iconUrl = 'https://cdn.shopify.com/s/files/1/0809/8955/2985/files/search_1.svg?v=1789061778';

  function addSearchIcons() {
    var searchLinks = document.querySelectorAll(
      '.menu-drawer__menu a[href="/search"], ' +
      '.menu-drawer__menu a[href^="/search?"], ' +
      '.header__inline-menu a[href="/search"], ' +
      '.header__inline-menu a[href^="/search?"]'
    );

    searchLinks.forEach(function (link) {
      // Ne kerüljön ugyanahhoz a linkhez több ikon
      if (link.querySelector('.menu-search-icon')) return;

      var icon = document.createElement('img');

      icon.src = iconUrl;
      icon.alt = '';
      icon.className = 'menu-search-icon';
      icon.setAttribute('aria-hidden', 'true');

      icon.style.display = 'block';
      icon.style.width = '20px';
      icon.style.height = '20px';
      icon.style.marginLeft = '8px';
      icon.style.objectFit = 'contain';
      icon.style.flexShrink = '0';

      link.style.display = 'flex';
      link.style.alignItems = 'center';

      // Ikon a Keresés felirat után
      link.appendChild(icon);
    });
  }

  // Betöltés után futtatás
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addSearchIcons);
  } else {
    addSearchIcons();
  }

  // Mobilmenü megnyitásakor is ellenőrizze
  document.addEventListener('click', function () {
    window.setTimeout(addSearchIcons, 100);
  });

  // Témaszerkesztőben újratöltött szekciók kezelése
  document.addEventListener('shopify:section:load', function () {
    addSearchIcons();
  });
})();
